// Ortak sabitler
export const BUILDING_NAME_MAPPING = {
  "MÜHENDİSLİK FAKÜLTESİ GİRİŞ KAPISI": "Mühendislik Fakültesi",
  "MESLEK YÜKSEKOKULU GİRİŞ KAPISI": "Meslek Yüksekokulu",
  "SAĞLIK BİLİMLERİ FAKÜLTESİ GİRİŞ KAPISI": "Sağlık Bilimleri Fakültesi",
  "DİŞ HEKİMLİĞİ FAKÜLTESİ GİRİŞ KAPISI": "Diş Hekimliği Fakültesi",
  "KÜTÜPHANE GİRİŞ KAPISI": "Kütüphane",
  "REKTÖRLÜK GİRİŞ KAPISI": "Rektörlük Binası",
  "KAFETERYA GİRİŞ KAPISI": "Kafeterya",
  "SPOR SALONU GİRİŞ KAPISI": "Spor Salonu",
  "ETKİNLİK ALANI GİRİŞ KAPISI": "Etkinlik Alanı",
  "FANTOM VE PRAKİLİNİK LABORATUVARI GİRİŞ KAPISI": "Fantom ve Prakilinik Laboratuvarı",
  "A GİRİŞ KAPISI": "A Giriş Kapısı",
  "B GİRİŞ KAPISI": "B Giriş Kapısı"
};

export const MANUAL_COORDINATES = [
  { x: 615, y: 270, building_name: "MÜHENDİSLİK FAKÜLTESİ GİRİŞ KAPISI" },
  { x: 595, y: 357, building_name: "MESLEK YÜKSEKOKULU GİRİŞ KAPISI" },
  { x: 547, y: 320, building_name: "SAĞLIK BİLİMLERİ FAKÜLTESİ GİRİŞ KAPISI" },
  { x: 320, y: 150, building_name: "DİŞ HEKİMLİĞİ FAKÜLTESİ GİRİŞ KAPISI" },
  { x: 280, y: 85, building_name: "KÜTÜPHANE GİRİŞ KAPISI" },
  { x: 245, y: 130, building_name: "REKTÖRLÜK GİRİŞ KAPISI" },
  { x: 210, y: 192, building_name: "KAFETERYA GİRİŞ KAPISI" },
  { x: 385, y: 221, building_name: "SPOR SALONU GİRİŞ KAPISI" },
  { x: 421, y: 160, building_name: "ETKİNLİK ALANI GİRİŞ KAPISI" },
  { x: 485, y: 283, building_name: "FANTOM VE PRAKİLİNİK LABORATUVARI GİRİŞ KAPISI" },
  // A ve B girişleri (değerleri gerekirse elle düzeltin)
  { x: 675, y: 215, building_name: "A GİRİŞ KAPISI" },
  { x: 365, y: 75,  building_name: "B GİRİŞ KAPISI" }
];

// Mobil için ayrı koordinatlar (800x450 bazlı). Boş bırakmak isterseniz [] yapabilirsiniz.
export const MOBILE_COORDINATES = [
  { x: 630, y: 270, building_name: "MÜHENDİSLİK FAKÜLTESİ GİRİŞ KAPISI" },
  { x: 595, y: 357, building_name: "MESLEK YÜKSEKOKULU GİRİŞ KAPISI" },
  { x: 547, y: 320, building_name: "SAĞLIK BİLİMLERİ FAKÜLTESİ GİRİŞ KAPISI" },
  { x: 320, y: 150, building_name: "DİŞ HEKİMLİĞİ FAKÜLTESİ GİRİŞ KAPISI" },
  { x: 280, y: 85, building_name: "KÜTÜPHANE GİRİŞ KAPISI" },
  { x: 245, y: 130, building_name: "REKTÖRLÜK GİRİŞ KAPISI" },
  { x: 210, y: 192, building_name: "KAFETERYA GİRİŞ KAPISI" },
  { x: 385, y: 221, building_name: "SPOR SALONU GİRİŞ KAPISI" },
  { x: 421, y: 160, building_name: "ETKİNLİK ALANI GİRİŞ KAPISI" },
  { x: 485, y: 283, building_name: "FANTOM VE PRAKİLİNİK LABORATUVARI GİRİŞ KAPISI" },
  { x: 710, y: 225, building_name: "A GİRİŞ KAPISI" },
  { x: 360, y: 75,  building_name: "B GİRİŞ KAPISI" }
];


